import { GraphQLQuery } from 'aws-amplify/api';
import { client } from '../../email-api-integration';
import { showErrorNotifications } from '../../../components/ServiceNotifications';
import { 
    listAllPersonas, 
    listAllAliases, 
    listAllTags, 
    listAllMessages, 
    listAllContacts 
} from './queries';

export const fetchAllPersonas = async ({
    filter = {},
    limit = 100,
    nextToken = null
}: {
    filter?: any,
    limit?: number,
    nextToken?: string | null
} = {}) => {
    try {
        const response = await client.graphql<GraphQLQuery<any>>({
            query: listAllPersonas,
            variables: { filter, limit, nextToken }
        });
        return {
            items: response.data?.adminListPersonas.items || [],
            nextToken: response.data?.adminListPersonas.nextToken || null
        };
    } catch (e) {
        console.trace(e);
        showErrorNotifications(e);
        return { items: [], nextToken: null };
    }
};

export const fetchAllAliases = async ({
    filter = {},
    limit = 100,
    nextToken = null
}: {
    filter?: any,
    limit?: number,
    nextToken?: string | null
} = {}) => {
    try {
        const response = await client.graphql<GraphQLQuery<any>>({
            query: listAllAliases,
            variables: { filter, limit, nextToken }
        });
        return {
            items: response.data?.adminListAliases.items || [],
            nextToken: response.data?.adminListAliases.nextToken || null
        };
    } catch (e) {
        console.trace(e);
        showErrorNotifications(e);
        return { items: [], nextToken: null };
    }
};

export const fetchAllTags = async ({
    filter = {},
    limit = 100,
    nextToken = null
}: {
    filter?: any,
    limit?: number,
    nextToken?: string | null
} = {}) => {
    try {
        const response = await client.graphql<GraphQLQuery<any>>({
            query: listAllTags,
            variables: { filter, limit, nextToken }
        });
        return {
            items: response.data?.adminListTags.items || [],
            nextToken: response.data?.adminListTags.nextToken || null
        };
    } catch (e) {
        console.trace(e);
        showErrorNotifications(e);
        return { items: [], nextToken: null };
    }
};

export const fetchAllMessages = async ({
    filter = {},
    limit = 100,
    nextToken = null
}: {
    filter?: any,
    limit?: number,
    nextToken?: string | null
} = {}) => {
    try {
        const response = await client.graphql<GraphQLQuery<any>>({
            query: listAllMessages,
            variables: { filter, limit, nextToken }
        });
        return {
            items: response.data?.adminListMessages.items || [],
            nextToken: response.data?.adminListMessages.nextToken || null
        };
    } catch (e) {
        console.trace(e);
        showErrorNotifications(e);
        return { items: [], nextToken: null };
    }
};

export const fetchAllContacts = async ({
    filter = {},
    limit = 100,
    nextToken = null
}: {
    filter?: any,
    limit?: number,
    nextToken?: string | null
} = {}) => {
    try {
        const response = await client.graphql<GraphQLQuery<any>>({
            query: listAllContacts,
            variables: { filter, limit, nextToken }
        });
        return {
            items: response.data?.adminListContacts.items || [],
            nextToken: response.data?.adminListContacts.nextToken || null
        };
    } catch (e) {
        console.trace(e);
        showErrorNotifications(e);
        return { items: [], nextToken: null };
    }
};
